/**
 * @generated SignedSource<<47106549cd6ea23d9e005ca430b256b6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type components_nativeIssueTable_ComponentsInlineEditCell_fieldRef$data = {
  readonly id: string;
  readonly lazyIsEditableInIssueView?: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"components_issueFieldComponentsInlineEditFull_ComponentsInlineEditViewWithIsEditable_fragmentRef">;
  readonly " $fragmentType": "components_nativeIssueTable_ComponentsInlineEditCell_fieldRef";
};
export type components_nativeIssueTable_ComponentsInlineEditCell_fieldRef$key = {
  readonly " $data"?: components_nativeIssueTable_ComponentsInlineEditCell_fieldRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"components_nativeIssueTable_ComponentsInlineEditCell_fieldRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "components_nativeIssueTable_ComponentsInlineEditCell_fieldRef",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "condition": "isInlineEditingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "lazyIsEditableInIssueView"
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "components_issueFieldComponentsInlineEditFull_ComponentsInlineEditViewWithIsEditable_fragmentRef"
    }
  ],
  "type": "JiraComponentsField"
};

(node as any).hash = "464cf035608be826c9250669fd7b79b4";

export default node;
